import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../state/helpers/IntlProps"
import { PAYMENT_SOURCE } from "../../state/helpers/Payment"
import { getPaymentSourceOptions } from "./utils"


type OwnProps = {
    intl: Intl
    multi: boolean
    onChange: (selectedOpts: string[], selectedOptsLabels: string) => void
}

const PaymentSourceSelect = (props: OwnProps) => {

    const [selectedOption, setSelectedOption] = useState<PAYMENT_SOURCE | PAYMENT_SOURCE[]>([])

    const onChangeSelect = (selectedOpts) => {

        setSelectedOption(selectedOpts)

        if (props.multi) {
            props.onChange(selectedOpts.map(option => option.value), selectedOpts.map(option => option.label).join(","))
        } else {
            props.onChange(selectedOpts.value, selectedOpts.label)
        }

    }

    return <Select
        id="payment-source-select"
        name="payment-source-select"
        multi={props.multi}
        value={selectedOption}
        onChange={onChangeSelect}
        options={getPaymentSourceOptions(props.intl)}
    />
}

export default injectIntl(PaymentSourceSelect)


// WEBPACK FOOTER //
// ./src/payment/components/paymentSourceSelect.tsx